module.exports = __webpack_public_path__ + "img/Kazakhstan.56f1b893.svg";